import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const CreditreportsummaryEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		fullname: yup.string().nullable().label($t('fullname')),
		firstname: yup.string().nullable().label($t('firstname')),
		middlename: yup.string().nullable().label($t('middlename')),
		lastname: yup.string().nullable().label($t('lastname')),
		addline1: yup.string().nullable().label($t('addline1')),
		voterid: yup.string().nullable().label($t('voterid')),
		nationalid: yup.string().nullable().label($t('nationalid')),
		noofactiveaccounts: yup.string().nullable().label($t('noofactiveaccounts')),
		numberofpastdueaccounts: yup.string().nullable().label($t('numberofpastdueaccounts')),
		totaloutstandingbalance: yup.string().nullable().label($t('totaloutstandingbalance')),
		totalinstallmentamount: yup.string().nullable().label($t('totalinstallmentamount')),
		mfnumberofopenaccounts: yup.string().nullable().label($t('mfnumberofopenaccounts')),
		mfnumberofpastdueaccounts: yup.string().nullable().label($t('mfnumberofpastdueaccounts')),
		mftotaloutstandingbalance: yup.string().nullable().label($t('mftotaloutstandingbalance')),
		mfrecentaccount: yup.string().nullable().label($t('mfrecentaccount')),
		mfinstallmentamount: yup.string().nullable().label($t('mfinstallmentamount')),
		mftotalpastdueamount: yup.string().nullable().label($t('mftotalpastdueamount')),
		userid: yup.number().nullable().label($t('userid')),
		creditscore: yup.string().nullable().label($t('creditscore')),
		total_utilization: yup.string().nullable().label($t('totalUtilization')),
		total_credit_exposure: yup.string().nullable().label($t('totalCreditExposure')),
		credit_card_utilization: yup.string().nullable().label($t('creditCardUtilization')),
		mrs: yup.string().nullable().label($t('mrs')),
		ers: yup.string().nullable().label($t('ers')),
		rdate: yup.string().nullable().label($t('rdate'))
	});
	// form default values
	const formDefaultValues = {
		fullname: '', 
		firstname: '', 
		middlename: '', 
		lastname: '', 
		addline1: '', 
		voterid: '', 
		nationalid: '', 
		noofactiveaccounts: '', 
		numberofpastdueaccounts: '', 
		totaloutstandingbalance: '', 
		totalinstallmentamount: '', 
		mfnumberofopenaccounts: '', 
		mfnumberofpastdueaccounts: '', 
		mftotaloutstandingbalance: '', 
		mfrecentaccount: '', 
		mfinstallmentamount: '', 
		mftotalpastdueamount: '', 
		userid: '', 
		creditscore: '', 
		total_utilization: '', 
		total_credit_exposure: '', 
		credit_card_utilization: '', 
		mrs: '', 
		ers: '', 
		rdate: "(CONVERT([date],getdate()))", 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/creditreportsummary`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="CreditreportsummaryEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editCreditReportSummary')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('fullname')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="fullname"  onChange={formik.handleChange}  value={formik.values.fullname}   label={$t('fullname')} type="text" placeholder={$t('enterFullname')}        className={inputClassName(formik?.errors?.fullname)} />
                                                <ErrorMessage name="fullname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('firstname')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="firstname"  onChange={formik.handleChange}  value={formik.values.firstname}   label={$t('firstname')} type="text" placeholder={$t('enterFirstname')}        className={inputClassName(formik?.errors?.firstname)} />
                                                <ErrorMessage name="firstname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('middlename')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="middlename"  onChange={formik.handleChange}  value={formik.values.middlename}   label={$t('middlename')} type="text" placeholder={$t('enterMiddlename')}        className={inputClassName(formik?.errors?.middlename)} />
                                                <ErrorMessage name="middlename" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('lastname')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="lastname"  onChange={formik.handleChange}  value={formik.values.lastname}   label={$t('lastname')} type="text" placeholder={$t('enterLastname')}        className={inputClassName(formik?.errors?.lastname)} />
                                                <ErrorMessage name="lastname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('addline1')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="addline1"  onChange={formik.handleChange}  value={formik.values.addline1}   label={$t('addline1')} type="text" placeholder={$t('enterAddline1')}        className={inputClassName(formik?.errors?.addline1)} />
                                                <ErrorMessage name="addline1" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('voterid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="voterid"  onChange={formik.handleChange}  value={formik.values.voterid}   label={$t('voterid')} type="text" placeholder={$t('enterVoterid')}        className={inputClassName(formik?.errors?.voterid)} />
                                                <ErrorMessage name="voterid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('nationalid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="nationalid"  onChange={formik.handleChange}  value={formik.values.nationalid}   label={$t('nationalid')} type="text" placeholder={$t('enterNationalid')}        className={inputClassName(formik?.errors?.nationalid)} />
                                                <ErrorMessage name="nationalid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('noofactiveaccounts')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="noofactiveaccounts"  onChange={formik.handleChange}  value={formik.values.noofactiveaccounts}   label={$t('noofactiveaccounts')} type="text" placeholder={$t('enterNoofactiveaccounts')}        className={inputClassName(formik?.errors?.noofactiveaccounts)} />
                                                <ErrorMessage name="noofactiveaccounts" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('numberofpastdueaccounts')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="numberofpastdueaccounts"  onChange={formik.handleChange}  value={formik.values.numberofpastdueaccounts}   label={$t('numberofpastdueaccounts')} type="text" placeholder={$t('enterNumberofpastdueaccounts')}        className={inputClassName(formik?.errors?.numberofpastdueaccounts)} />
                                                <ErrorMessage name="numberofpastdueaccounts" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('totaloutstandingbalance')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="totaloutstandingbalance"  onChange={formik.handleChange}  value={formik.values.totaloutstandingbalance}   label={$t('totaloutstandingbalance')} type="text" placeholder={$t('enterTotaloutstandingbalance')}        className={inputClassName(formik?.errors?.totaloutstandingbalance)} />
                                                <ErrorMessage name="totaloutstandingbalance" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('totalinstallmentamount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="totalinstallmentamount"  onChange={formik.handleChange}  value={formik.values.totalinstallmentamount}   label={$t('totalinstallmentamount')} type="text" placeholder={$t('enterTotalinstallmentamount')}        className={inputClassName(formik?.errors?.totalinstallmentamount)} />
                                                <ErrorMessage name="totalinstallmentamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mfnumberofopenaccounts')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mfnumberofopenaccounts"  onChange={formik.handleChange}  value={formik.values.mfnumberofopenaccounts}   label={$t('mfnumberofopenaccounts')} type="text" placeholder={$t('enterMfnumberofopenaccounts')}        className={inputClassName(formik?.errors?.mfnumberofopenaccounts)} />
                                                <ErrorMessage name="mfnumberofopenaccounts" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mfnumberofpastdueaccounts')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mfnumberofpastdueaccounts"  onChange={formik.handleChange}  value={formik.values.mfnumberofpastdueaccounts}   label={$t('mfnumberofpastdueaccounts')} type="text" placeholder={$t('enterMfnumberofpastdueaccounts')}        className={inputClassName(formik?.errors?.mfnumberofpastdueaccounts)} />
                                                <ErrorMessage name="mfnumberofpastdueaccounts" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mftotaloutstandingbalance')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mftotaloutstandingbalance"  onChange={formik.handleChange}  value={formik.values.mftotaloutstandingbalance}   label={$t('mftotaloutstandingbalance')} type="text" placeholder={$t('enterMftotaloutstandingbalance')}        className={inputClassName(formik?.errors?.mftotaloutstandingbalance)} />
                                                <ErrorMessage name="mftotaloutstandingbalance" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mfrecentaccount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mfrecentaccount"  onChange={formik.handleChange}  value={formik.values.mfrecentaccount}   label={$t('mfrecentaccount')} type="text" placeholder={$t('enterMfrecentaccount')}        className={inputClassName(formik?.errors?.mfrecentaccount)} />
                                                <ErrorMessage name="mfrecentaccount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mfinstallmentamount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mfinstallmentamount"  onChange={formik.handleChange}  value={formik.values.mfinstallmentamount}   label={$t('mfinstallmentamount')} type="text" placeholder={$t('enterMfinstallmentamount')}        className={inputClassName(formik?.errors?.mfinstallmentamount)} />
                                                <ErrorMessage name="mfinstallmentamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mftotalpastdueamount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mftotalpastdueamount"  onChange={formik.handleChange}  value={formik.values.mftotalpastdueamount}   label={$t('mftotalpastdueamount')} type="text" placeholder={$t('enterMftotalpastdueamount')}        className={inputClassName(formik?.errors?.mftotalpastdueamount)} />
                                                <ErrorMessage name="mftotalpastdueamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('userid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label={$t('userid')} type="number" placeholder={$t('enterUserid')}  min={0}  step="any"    className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('creditscore')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="creditscore"  onChange={formik.handleChange}  value={formik.values.creditscore}   label={$t('creditscore')} type="text" placeholder={$t('enterCreditscore')}        className={inputClassName(formik?.errors?.creditscore)} />
                                                <ErrorMessage name="creditscore" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('totalUtilization')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="total_utilization"  onChange={formik.handleChange}  value={formik.values.total_utilization}   label={$t('totalUtilization')} type="text" placeholder={$t('enterTotalUtilization')}        className={inputClassName(formik?.errors?.total_utilization)} />
                                                <ErrorMessage name="total_utilization" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('totalCreditExposure')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="total_credit_exposure"  onChange={formik.handleChange}  value={formik.values.total_credit_exposure}   label={$t('totalCreditExposure')} type="text" placeholder={$t('enterTotalCreditExposure')}        className={inputClassName(formik?.errors?.total_credit_exposure)} />
                                                <ErrorMessage name="total_credit_exposure" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('creditCardUtilization')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="credit_card_utilization"  onChange={formik.handleChange}  value={formik.values.credit_card_utilization}   label={$t('creditCardUtilization')} type="text" placeholder={$t('enterCreditCardUtilization')}        className={inputClassName(formik?.errors?.credit_card_utilization)} />
                                                <ErrorMessage name="credit_card_utilization" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mrs')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mrs"  onChange={formik.handleChange}  value={formik.values.mrs}   label={$t('mrs')} type="text" placeholder={$t('enterMrs')}        className={inputClassName(formik?.errors?.mrs)} />
                                                <ErrorMessage name="mrs" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('ers')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ers"  onChange={formik.handleChange}  value={formik.values.ers}   label={$t('ers')} type="text" placeholder={$t('enterErs')}        className={inputClassName(formik?.errors?.ers)} />
                                                <ErrorMessage name="ers" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('rdate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="rdate" showButtonBar className={inputClassName(formik?.errors?.rdate)} dateFormat="yy-mm-dd" value={formik.values.rdate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="rdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
CreditreportsummaryEditPage.defaultProps = {
	primaryKey: 'report_id',
	pageName: 'creditreportsummary',
	apiPath: 'creditreportsummary/edit',
	routeName: 'creditreportsummaryedit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default CreditreportsummaryEditPage;
